import { http_client } from '@/plugins/http_client';

const API_BASE = '/api/consultorias';

export const fetchConsultorias = (params = {}) => {
  const { page, per_page, ...filters } = params;
  const query = new URLSearchParams();
  if (page) query.set('page', String(page));
  if (per_page) query.set('per_page', String(per_page));
  const qs = query.toString();
  return http_client(
    qs ? `/api/consultorias/jefatura?${qs}` : '/api/consultorias/jefatura',
    filters,
    'POST'
  );
};

export const getEstadosConsultorias = (params = {}) => {
  return http_client('/api/consultorias/estados', params, 'GET');
};

export const fetchControlActividades = (idConsultoria, params = {}) => {
  return http_client(`${API_BASE}/${idConsultoria}/jefatura/control-actividades`, params, 'GET');
};

export const getActividadesEntregable = (idEntregable, idConsultor, params = {}) => {
  return http_client(`${API_BASE}/entregables/${idEntregable}/consultores/${idConsultor}/actividades`, params, 'GET');
};

export const getActividadesJefatura = (idEntregableEmpleado, params = {}) => {
  return http_client(`/api/consultorias/jefatura/entregables-empleados/${idEntregableEmpleado}/actividades`, params, 'GET');
};

export const postActividadEntregable = (idEntregable, data) => {
  return http_client(`${API_BASE}/entregables/${idEntregable}/actividades`, data, 'POST');
};

export const postComentarioRechazo = (idEntregable, idActividad, data) => {
  return http_client(`${API_BASE}/entregables/${idEntregable}/actividades/${idActividad}/comentar`, data, 'PATCH');
};

export const getDetallesProrroga = (idConsultoria, params = {}) => {
  return http_client(`${API_BASE}/${idConsultoria}/ajustes-prorroga`, params, 'GET');
};

export const postCancelarEvaluacion = (idEntregable) => {
  return http_client(`${API_BASE}/jefatura/entregable/${idEntregable}/cancelar-evaluacion`, {}, 'POST');
};

export const postIniciarEvaluacion = (idEntregable) => {
  return http_client(`${API_BASE}/jefatura/entregable/${idEntregable}/iniciar-evaluacion`, {}, 'POST');
};

export const fetchConsultoresEntregable = (idEntregable, params = {}) => {
  return http_client(`${API_BASE}/jefatura/entregables/${idEntregable}/consultores`, params, 'POST');
};

export const postRechazarActividadEval = (idActividad, data) => {
  return http_client(`${API_BASE}/jefatura/actividad/${idActividad}/rechazar`, data, 'POST');
};

export const postAprobarActividadEval = (idActividad, data) => {
  return http_client(`${API_BASE}/jefatura/actividad/${idActividad}/aprobar`, data, 'POST');
};

export const postEvaluacionCompleta = (idEntregable, idConsultor) => {
  return http_client(`${API_BASE}/jefatura/entregable/${idEntregable}/consultores/${idConsultor}/completa`, {}, 'POST');
};

export const postCerrarCompleto = (idEntregableEmpleado, data = {}) => {
  return http_client(`/api/consultorias/jefatura/entregable/cerrar-completo/${idEntregableEmpleado}`, data, 'POST');
};

export const postEvaluacionIncompleta = (idEntregable, idConsultor) => {
  return http_client(`${API_BASE}/jefatura/entregable/${idEntregable}/consultores/${idConsultor}/incompleta`, {}, 'POST');
};

export const postCerrarIncompleto = (idEntregableEmpleado, data = {}) => {
  return http_client(`/api/consultorias/jefatura/entregable/cerrar-incompleto/${idEntregableEmpleado}`, data, 'POST');
};

export const postCerrarEvaluacion = (idEntregable, data = {}) => {
  const headers = data instanceof FormData ? { 'content-type': 'multipart/form-data' } : {};
  return http_client(`${API_BASE}/entregables/cerrar-evaluacion/${idEntregable}`, data, 'POST', headers);
};

export const patchJustificarEvaluacion = (idEntregable, justificacion) => {
  return http_client(`/api/consultorias/entregable/${idEntregable}/justificar-evaluacion`, { justificacion }, 'PATCH');
};

export default { fetchConsultorias, fetchControlActividades, getActividadesEntregable, postActividadEntregable, postComentarioRechazo, getDetallesProrroga };
